module.exports = __webpack_public_path__ + "img/celka_hydro.733a70a3.webp";